import type { FaireProductEntity } from "../../entity_types/product";

export const p_2h6d2fpjeq: FaireProductEntity = {
  token: "p_2h6d2fpjeq",
  type: "product",
  name: "Vegan Brownie Ganache - Single Serve",
  brandToken: "b_7qrub4tp9v",
  brandName: "Konscious Kitchen Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/08b4b487cce787c8ea635a8fbdc99b14fa8a0eae2e473195b16baf9212337abc.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a6da59229cc37c01b6ca52816ce6c41a223e0f1d6bad94c0df5ac71231c9087.png",
    "https://cdn.faire.com/fastly/4bf3bbdaf5618c2363be05adbc1b99d9edd041f4ab6e6789dce9ed04c4dd4962.png",
    "https://cdn.faire.com/fastly/828feaa3b2e0536ba4731b41510e318e6a5511535d28e263657feee86b41b8b4.png",
  ],
  priceDollars: 3.99,
  description:
    "Soft, fudgy vegan brownie topped with a smooth, creamy chocolate ganache that makes every bite rich and satisfying. Made without gluten, dairy, eggs, or refined sugars, this brownie delivers indulgent chocolate flavour using only Mad Clean ingredients. The texture is dense yet moist, with a luscious ganache layer that adds the perfect touch of decadence.\nA seriously satisfying treat for chocolate lovers who want indulgence without compromise.\n\nKey Features:\nGluten Free\nPaleo\nGrain Free\n7G of Protein\n\nIngredients:\nAlmond Flour, Organic Coconut Sugar, Organic Coconut Milk, Semi Sweet Chocolate (Cocoa Mass, Cocoa Butter, Brown Sugar), Pure Avocado Oil, Unsweetened Cocoa Powder, Organic Tapioca Starch, Organic Coconut Flour, Organic Golden Flaxseed powder,  Pure Vanilla Extract, Organic Coconut Oil, Himalayan Sea Salt \n\nShelf Life:\nRefrigerated – 3 weeks\nFrozen - 6 months\n\n",
  tags: [],
  msrpDollars: 5.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:15.422Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
